import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = authed
  const [bootstrapping, setBootstrapping] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function check() {
      if (!getToken()) {
        if (!cancelled) {
          setUser(false);
          setBootstrapping(false);
        }
        return;
      }
      try {
        const res = await api.get("/auth/me");
        if (!cancelled) setUser(res.data);
      } catch (e) {
        if (!cancelled) setUser(false);
      } finally {
        if (!cancelled) setBootstrapping(false);
      }
    }
    check();
    return () => {
      cancelled = true;
    };
  }, []);

  async function login(email, password) {
    const res = await api.post("/auth/login", { email, password });
    setToken(res.data.access_token);
    setUser(res.data.user);
    return res.data.user;
  }

  function logout() {
    setToken(null);
    setUser(false);
  }

  async function refreshUser() {
    if (!getToken()) return null;
    const res = await api.get("/auth/me");
    setUser(res.data);
    return res.data;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, bootstrapping, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

// Role helpers — keep UI logic centralized
export function can(user, action) {
  if (!user) return false;
  const role = user.role;
  switch (action) {
    case "manageUsers":
    case "deleteClient":
      return role === "admin";
    case "createClient":
    case "editClient":
    case "addSession":
    case "exportData":
    case "manageTrainingPrograms":
      return role === "admin" || role === "trainer";
    case "recordPayment":
    case "scheduleSession": // changing nextSession or status
      return role === "admin" || role === "trainer" || role === "front_desk";
    default:
      return false;
  }
}
